import { setInitialFilterInfo } from '../../index'
import { setFlySearchResponseData } from '../../../reducers/flySearchResponseData'

/**
 * The following function gets invoked during resetting filters
 * moving from 1 tab to another for SBS
 * */
export function loadSavedFilterInfo({ tabId = 1 }) {
  return (dispatch, getState) => {
    const flySearchResponseData = getState().flySearchResponseData
    dispatch(
      setInitialFilterInfo({
        payload: flySearchResponseData.filters[tabId],
        sbsParams: {
          activeTabId: tabId,
          prevTab: (tabId % 2) + 1,
        },
      })
    )
  }
}

/**
 * Code Smell: Nastiest way to reset Filter values
 */

export function setTabDefaultFilters({ tabId = 1 }) {
  return (dispatch, getState) => {
    const flySearchResponseData = structuredClone(getState().flySearchResponseData)
    flySearchResponseData.filters[tabId] = {
      sliceRefId: tabId,
      filterDefaults: getState().filterInfo.defaults,
      AIRLINES: getState().airlinesFilter,
      AIRPORTS: getState().airportsFilter,
      ATTRIBUTES: getState().attributesFilter,
      DEFAULT_TAB_ITEMS: getState().filterInfo.defaults.DEFAULT_TAB_ITEMS,
      timeDefaults: getState().filterInfo.defaults.TIME,
      NUM_OF_STOPS: getState().stopsFilter,
      SLICE_ARRAY: getState().filterInfo.defaults.SLICE_ARRAY,
      TIME: getState().timeFilter,
    }
    dispatch(setFlySearchResponseData(flySearchResponseData))
  }
}
